import React from 'react';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

class BrandWeLove extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.bannerImageDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;
    if (bannerDetail === undefined) {
      return null;
    }
    const imageList = bannerDetail.map((bannerimagedetails, j) => {
      let bannerImgUrl = '';
      bannerImgUrl =
        bannerimagedetails.imageUrl.indexOf('?') == -1
          ? bannerimagedetails.imageUrl
          : bannerimagedetails.imageUrl.substr(0, bannerimagedetails.imageUrl.indexOf('?'));
      return (
        <Col xs={6} key={j} className="own-section">
          <a
            href={bannerimagedetails.bannerUrlLink}
            data-ga-event-category="bannerTap"
            data-ga-event-action={`${sectionName}/${bannerimagedetails.componentPosition}/${widgetType}`}
            data-ga-event-label={`${bannerImgUrl}/${bannerimagedetails.bannerPosition}`}
            data-gtm-bnr-position={`${bannerimagedetails.componentPosition}`}
            data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(bannerimagedetails.imageUrl) ||
              ''}`}
            data-gtm-bnr-id={`${bannerimagedetails.uId || ''}`}
          >
            <img src={`${replaceWithJioCDN(bannerimagedetails.imageUrl)}`} />
          </a>
        </Col>
      );
    });

    return <div className="fourimage-com row">{imageList}</div>;
  }
}

export default BannerWrapper(BrandWeLove);
